import React from "react";
import green from "../images/green.svg";
import pink from "../images/pink.svg";
import white from "../images/white.svg";
import yellow from "../images/yellow.svg";
import orange from "../images/orange.svg";
import arrow from "../images/arrow.svg";
import { Link } from "react-router-dom";

const Hero = ({ color }) => {
  return (
    <div className="flex flex-col items-center base-wrapper mt-[150px] relative">
      <img
        src={
          color === "green"
            ? green
            : color === "white"
            ? white
            : color === "pink"
            ? pink
            : color === "orange"
            ? orange
            : yellow
        }
        alt=""
        className="absolute scale-[2] md:scale-125 -right-[100px] -top-[100px] md:-top-[220px] md:right-3 -z-10"
      />
      <h1 className="text-[#FFFFFF] font-extrabold text-[30px] sm:text-[40px] md:text-[72.047px]">
        INTROVERSE
      </h1>
      <p className="text-[#A8A8A8] font-rub text-[16px] md:text-[27.5px]">
        A new age Pseudonymous Social media
      </p>
      <Link to="/join" className="btn mt-[100px]">
        Join now <img src={arrow} alt="" />
      </Link>
      <div className="mt-[100px] md:mt-[87px] text-[20px]">
        <a href="#about">Scroll</a>
      </div>
      <a href="#about">
        <img
          src={arrow}
          alt=""
          className="w-[20px] md:w-[35px] mt-[15px] md:mt-[10px] mb-[20px] rotate-90"
        />
      </a>
    </div>
  );
};

export default Hero;
